import { createReducer, on } from '@ngrx/store';
import LogsActions from '../../actions/generations/summary.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

interface WizardCompletionState {
  logs: any;
}

const mock = [
  {
    sid: '020fab04-a26e-4cbf-80ef-d5ee3b64bff7',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758193843650,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758193843650,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'TABLE',
    aiGeneratedObjectsCount: 1,
    userAcceptedObjectsCount: 1,
    duplicatesFoundCount: 0,
    deployedObjectsCount: 1,
    manuallyCreatedObjectsCount: 1
  },
  {
    sid: '23d8414e-af9a-4c0d-81fb-0ead77ab63ba',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758191339247,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758191339247,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'ROLE',
    aiGeneratedObjectsCount: 1,
    userAcceptedObjectsCount: 1,
    duplicatesFoundCount: 1,
    deployedObjectsCount: 0,
    manuallyCreatedObjectsCount: 1
  },
  {
    sid: 'a1225127-b9bc-4cd3-8c47-a4253e702ab0',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758193843655,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758193843655,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'FIELD',
    aiGeneratedObjectsCount: 9,
    userAcceptedObjectsCount: 9,
    duplicatesFoundCount: 8,
    deployedObjectsCount: 1,
    manuallyCreatedObjectsCount: 1
  },
  {
    sid: 'b63d24eb-c926-473d-9edc-46885e73d5da',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758110325659,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758110325659,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'MODULE',
    aiGeneratedObjectsCount: 3,
    userAcceptedObjectsCount: 1,
    duplicatesFoundCount: 0,
    deployedObjectsCount: 1,
    manuallyCreatedObjectsCount: 1
  },
  {
    sid: 'd61a1426-d669-4213-bc0f-37176bc6fc33',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758193685769,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758193685769,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'USER_STORY',
    aiGeneratedObjectsCount: 11,
    userAcceptedObjectsCount: 10,
    duplicatesFoundCount: 0,
    deployedObjectsCount: 10,
    manuallyCreatedObjectsCount: 1
  },
  {
    sid: 'e798bd62-a95e-49ac-b823-9019cdc812a4',
    createdBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    createdDate: 1758110754552,
    modifiedBy: 'c2acc2d6-cd41-43a6-bb94-b504c9072643',
    modifiedDate: 1758110754552,
    recDeleted: false,
    appId: 'fc987f48-f9a3-479f-9ce1-c9ab616a7624',
    orgId: 'c2d25bf5-a24b-4e9a-b037-95aa20b3859a',
    generationId: 'd5dac29b-3079-42ee-a06a-f13788e4f578',
    modelType: 'PROCESS',
    aiGeneratedObjectsCount: 6,
    userAcceptedObjectsCount: 5,
    duplicatesFoundCount: 0,
    deployedObjectsCount: 5,
    manuallyCreatedObjectsCount: 1
  }
];

const initialState: WizardCompletionState = {
  logs: []
};

const logsReducer = createReducer(
  initialState,
  on(LogsActions.setLogs, (state, { data }) => {
    return {
      ...state,
      logs: [...data]
    };
  }),
  on(LogsActions.clearLogs, (state) => {
    return {
      ...state,
      logs: []
    };
  }),
  on(GenerationActions.resetGeneration, (state) => ({
    ...initialState
  }))
);

export { logsReducer, WizardCompletionState };
